import { BorderBox, Text, TextSmall } from '@trmediaab/zebra';
import { CheckCircle } from '@trmediaab/zebra-icons';

import { useDomSafeId } from '../../utils/useDomSafeId';

interface RenderInputProps {
  label?: string;
  description?: string;
  render: (id: string) => React.ReactNode;
  containerStyles?: React.ComponentProps<typeof BorderBox>;
}

export const RenderInput = ({
  label,
  description,
  render,
  containerStyles,
}: RenderInputProps) => {
  const id = useDomSafeId();

  return (
    <BorderBox {...containerStyles}>
      {label != null && (
        <TextSmall
          as="label"
          htmlFor={id}
          display="block"
          fontWeight="semiBold"
          mb="2"
        >
          {label.toUpperCase()}
        </TextSmall>
      )}
      {render(id)}
      {description && (
        <Text mt="2" color="text.faded">
          <CheckCircle color="checkout.icon2" size="16px" mt="-2px" />{' '}
          {description}
        </Text>
      )}
    </BorderBox>
  );
};
